<div id="container-home-page">
  <!-- <ngb-carousel
    [showNavigationArrows]="false"
    [showNavigationIndicators]="false">
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper">
        <img
          src="assets/images/homepage/hompage-header-tsolife.png"
          alt="TSOLife" />
      </div>
      <div class="carousel-caption text-start">
        <h1>BUILD A HAPPIER,<br />MORE CONNECTED SENIOR LIVING COMMUNITY</h1>
        <h2 class="mt-4">
          Our fully integrated platform collects and centralizes your resident
          data, events, and communications,<br />
          so you can deliver a more fulfilling resident experience.
        </h2>
        <a
          class="btn btn-danger homepage-contact-btn btn-lg m-btn-schedule cursor-pointer"
          href="https://get.tsolife.com/contact-us"
          >CONTACT US TO LEARN MORE</a
        >
      </div>
    </ng-template>
  </ngb-carousel> -->

  <div class="row justify-content-around flex-wrap align-items-center bg-white">
    <div class="col-5 d-flex justify-content-center custom-my p-5">
      <div>
        <div class="text-black homepage-title">
          <h1 class="fw-bold">
            Elevating Senior Living Through Person-Centered Data
          </h1>
          <h2 class="mt-4 fw-light">
            TSOLife's resident insight and experience platform is designed to
            empower senior living operators with actionable insights that
            facilitate real-time data-driven decisions.
          </h2>
        </div>
        <div class="d-flex flex-wrap mt-4">
          <a
            class="btn btn-lg schedule-demo-button text-white fw-medium px-4"
            href="https://calendly.com/tsolife-david-sawyer/60min"
            target="_blank"
            >Schedule Demo
          </a>
          <button
            (click)="openVideo()"
            class="btn btn-lg watch-v-button ms-md-4 ms-lg-4 fw-medium px-4">
            Watch Our Video
          </button>
        </div>
      </div>
    </div>
    <div
      class="col-5 d-flex justify-content-sm-center justify-content-md-center justify-content-lg-start custom-my">
      <img
        class="img-fluid rounded"
        src="assets/images/homepage/main-image.png"
        alt="" />
    </div>
  </div>

  <div class="row home-page-light-blue-bg-color justify-content-center">
    <div class="col-12 p-5">
      <h1 class="text-center text-black mb-5">
        Trusted by leading organizations
      </h1>
      <owl-carousel-o
        [options]="companiesCarousel"
        class="events navs-carousel">
        <ng-template *ngFor="let item of carouselImgs" carouselSlide>
          <div class="col-6 mx-auto">
            <img class="img-fluid rounded" [src]="item" alt="" />
          </div>
        </ng-template>
      </owl-carousel-o>
    </div>
  </div>

  <div class="row justify-content-center bg-white mt-0">
    <div class="col-6 text-center text-black mt-5">
      <h2>Reshaping Senior Living for Quality and Efficiency</h2>
      <p class="mt-4 font-size-17">
        Our Al-powered platform transforms senior living operations by
        simplifying data creation through embedded analytics, delivering
        person-centered data for enhanced resident quality of life and
        transformative outcomes for staff.
      </p>
    </div>
  </div>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row align-items-center invert-sm-order">
      <div class="col-md-5 offset-md-1">
        <div class="card-body mtb-50">
          <div
            class="rounded bg-primary-soft p-2 col-5 justify-content-center d-flex mb-4 text-black fw-medium">
            Resident Insights
          </div>
          <h2 class="card-title mb-4 img-info-title titles-color">
            Detailed Resident Insights
          </h2>
          <p class="card-text img-info-body">
            Harness the power of data mining and transcription with our
            one-of-a-kind platform, Minerva, to effortlessly transform recorded
            audio interviews into comprehensive digital resident profiles,
            providing comprehensive insights into each individual.
          </p>
          <p
            routerLink="resident-insights"
            class="text-decoration-underline cursor-pointer">
            Learn More
          </p>
        </div>
      </div>

      <div class="col-md-5">
        <img
          class="card-img img-fluid"
          src="assets/images/homepage/features/detailed-resident-insights.png"
          alt="TSOLife Calendar" />
      </div>
    </div>
  </div>

  <!------>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row">
      <div class="offset-md-1 col-md-5">
        <div class="card-body">
          <img
            class="card-img img-fluid"
            src="assets/images/homepage/features/elevated-resident-experiences.png"
            alt="TSOLife Calendar" />
        </div>
      </div>

      <div class="col-md-5 d-flex align-items-center">
        <div class="card-body">
          <div
            class="rounded bg-primary-soft p-2 col-5 justify-content-center d-flex mb-4 text-black fw-medium">
            Resident Experience
          </div>
          <h2 class="card-title mb-4 img-info-title titles-color">
            Elevated Resident Experiences
          </h2>
          <p class="card-text img-info-body">
            Leverage the power of person-centered data to craft tailored and
            enriched experiences through automated actionable insights,
            personalized inclusivity calendars, friend matching, newsletters,
            and family and resident communication apps.
          </p>
          <p
            routerLink="resident-experiences"
            class="text-decoration-underline cursor-pointer">
            Learn More
          </p>
        </div>
      </div>
    </div>
  </div>

  <!------>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row align-items-center invert-sm-order">
      <div class="col-md-5 offset-md-1">
        <div class="card-body mtb-50">
          <div
            class="rounded bg-primary-soft p-2 col-5 justify-content-center d-flex mb-4 text-black fw-medium">
            Quality of Life
          </div>
          <h2 class="card-title mb-4 img-info-title titles-color">
            Enhanced Quality of Life
          </h2>
          <p class="card-text img-info-body">
            Utilize our validated Quality of Life scales to assess residents'
            happiness and well-being in real-time, providing a quantifiable
            measure of the long-term impact of programs on resident
            satisfaction.
          </p>
          <p
            routerLink="quality-of-life"
            class="text-decoration-underline cursor-pointer">
            Learn More
          </p>
        </div>
      </div>

      <div class="col-md-5">
        <img
          class="card-img img-fluid"
          src="assets/images/homepage/features/enhanced-quality-of-life.png"
          alt="TSOLife Calendar" />
      </div>
    </div>
  </div>

  <!------>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row">
      <div class="offset-md-1 col-md-5">
        <div class="card-body">
          <img
            class="card-img img-fluid"
            src="assets/images/homepage/features/streamlined-sales-efficiency.png"
            alt="TSOLife Calendar" />
        </div>
      </div>

      <div class="col-md-5 d-flex align-items-center">
        <div class="card-body">
          <div
            class="rounded bg-primary-soft p-2 col-5 justify-content-center d-flex mb-4 text-black fw-medium">
            Sales Support
          </div>
          <h2 class="card-title mb-4 img-info-title titles-color">
            Streamlined Sales Efficiency
          </h2>
          <p class="card-text img-info-body">
            Elevate the prospective resident journey with our intelligent sales
            support tool, empowering teams to forge meaningful connections and
            provide unparalleled experiences for potential residents.
          </p>
          <p
            routerLink="sales-support-tool"
            class="text-decoration-underline cursor-pointer">
            Learn More
          </p>
        </div>
      </div>
    </div>
  </div>

  <!------>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row align-items-center invert-sm-order">
      <div class="col-md-5 offset-md-1">
        <div class="card-body mtb-50">
          <div
            class="rounded bg-primary-soft p-2 col-5 justify-content-center d-flex mb-4 text-black fw-medium">
            Survey and Feedback
          </div>
          <h2 class="card-title mb-4 img-info-title titles-color">
            Detailed Community Insights
          </h2>
          <p class="card-text img-info-body">
            Gain comprehensive community insights in real-time through our
            survey and feedback platform, empowering users to achieve
            exceptional results with automated investigations and instant
            resolution strategies.
          </p>
          <p
            routerLink="survey-feedback-platform"
            class="text-decoration-underline cursor-pointer">
            Learn More
          </p>
        </div>
      </div>

      <div class="col-md-5">
        <img
          class="card-img img-fluid"
          src="assets/images/homepage/features/detailed-community-insights.png"
          alt="TSOLife Calendar" />
      </div>
    </div>
  </div>

  <div class="row p-4 home-page-light-blue-bg-color font-size-17">
    <div class="row justify-content-center mb-5 mt-5">
      <div class="col-10 rounded schedule-demo-bg-color d-flex flex-wrap ps-0">
        <div class="col-sm-12 col-lg-4">
          <img
            class="card-img img-fluid"
            src="assets/images/homepage/content/couple.png"
            alt="" />
        </div>
        <div
          class="col-sm-12 col-lg-8 p-5 text-light font-size-18 justify-content-center d-flex align-items-center">
          <div>
            <p>
              "TSOLife has been a wonderful partnership. We have already seen
              the impact of Al on our wellness program and we are seeing
              improved quality of life in our residents. We see more smiles,
              more laughter, more joy, and a greater sense of purpose. "
            </p>
            <p>Dylan P., Priority Life Care</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex flex-wrap justify-content-center mb-5">
      <div class="col-sm-12 col-lg-5 p-5 card my-sm-3 me-lg-3">
        <p>
          "I've been really thrilled with the program. The interview process
          gives us a much better ability to connect with the residents…we're not
          sitting there with a clipboard and a pen, we're sitting there
          eye-to-eye. It's much more personal."
        </p>
        <p>Terri R., Benchmark Senior Living</p>
      </div>
      <div class="col-sm-12 col-lg-5 p-5 card my-sm-3 ms-lg-3">
        <p>
          "Because of TSOLife, I'm able to connect residents together that I
          wouldn't normally connect because of the common points of interest and
          friend matching through their profiles. I have also been able to
          create personalized engagement opportunities based on their profiles
          and be able to truly customize the calendar and change up our days."
        </p>
        <p>Natasha S., Sodalis Milton</p>
      </div>
    </div>
  </div>

  <div class="row justify-content-center p-5 text-white schedule-demo-bg-color">
    <div class="col-5 my-4">
      <h2 class="text-center">Ready to get started ?</h2>
      <p class="text-center mt-4 font-size-20">
        Get a firsthand look at how our platform is enabling operators to
        deliver exceptional resident experiences and thrive in an ever-evolving
        industry landscape.
      </p>
      <div class="d-flex justify-content-center mt-4">
        <a
          class="btn btn-lg btn-outline-light mx-auto"
          href="https://calendly.com/tsolife-david-sawyer/60min"
          target="_blank">
          Schedule Demo
        </a>
      </div>
    </div>
  </div>
</div>
